
export let VenditeSettimanaliOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    stacked: false,
    scales: {
      y: {
        type: 'linear',
        display: false,
        position: 'left',
      },
      y1: {
        type: 'linear',
        display: false,
        grid: {
          drawOnChartArea: false,
        },
      },
      y2: {
        type: 'linear',
        display: false,
        grid: {
          drawOnChartArea: false,
        },
      },
    },
  };
  
  const labels = [];
  
export let VenditeSettimanaliData = {
    labels: labels,
    datasets: [
      {
        label: 'Settimana corrente',
        data: [28, 48, 40, 19, 86, 27, 90],
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        yAxisID: 'y',
      },
      {
        label: 'Settimana Precedente',
        data: [28, 48, 40, 19, 86, 27, 90],
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
        yAxisID: 'y1',
      },
      {
        label: 'Settimana Anno Precedente',
        data: [28, 48, 40, 19, 86, 27, 90],
        borderColor: 'rgb(10, 220, 80)',
        backgroundColor: 'rgba(10, 220, 80, 0.5)',
        yAxisID: 'y2',
      },
    ],
  };
  